(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
/* Before / after slider: the range input drives --pos; a short nudge on first view shows it moves. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ba-split]').forEach(function (fig) {
    if (reduce || !('IntersectionObserver' in window)) { fig.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect(); fig.classList.add('is-in');
    }, { threshold: .35 });
    io.observe(fig);
  });
  document.querySelectorAll('[data-ba]').forEach(function (fig) {
    var r = fig.querySelector('.ba__range');
    var set = function (v) { fig.style.setProperty('--pos', v + '%'); };
    r.addEventListener('input', function () { set(r.value); fig.dataset.touched = '1'; });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect();
      var t0 = null, keys = [50, 30, 68, 50];
      (function step(ts) {
        if (fig.dataset.touched) return;
        t0 = t0 || ts; var p = Math.min((ts - t0) / 2400, 1), seg = Math.min(Math.floor(p * 3), 2), f = p * 3 - seg;
        var e = f < .5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2, v = keys[seg] + (keys[seg + 1] - keys[seg]) * e;
        set(v); r.value = v; if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    }, { threshold: .5 });
    io.observe(fig);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
/* Photo carousel: scroll-snap track driven by arrows, dots, drag, keys and an optional timer. */
(function () {
  function init(root) {
    if (root.dataset.hcReady) return;
    root.dataset.hcReady = '1';
    var track = root.querySelector('[data-hc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hc-dot]'));
    var prev = root.querySelector('[data-hc-prev]'), next = root.querySelector('[data-hc-next]');
    var count = root.querySelector('[data-hc-count]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = reduce ? 0 : Number(root.dataset.interval) || 0;
    var current = 0, timer = null, hold = false, visible = false;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    slides.forEach(function (s, i) { s.style.setProperty('--i', Math.min(i, 5)); });

    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function setActive(i) {
      if (i === current && slides[i].classList.contains('is-active')) return;
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      restart();
    }
    function go(i, smooth) {
      i = (i + slides.length) % slides.length;
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({ left: Math.min(left, track.scrollWidth), behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    function nearest() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      if (x >= maxScroll()) return slides.length - 1 > current && current >= slides.length - 3 ? current : slides.length - 1;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - slides[0].offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { if (!dragging) setActive(nearest()); }, 90);
    }, { passive: true });

    function tick() { go(current + 1); }
    function stop() { clearTimeout(timer); timer = null; root.classList.remove('is-playing'); }
    function restart() {
      stop();
      if (!interval || hold || !visible || slides.length < 2) return;
      void root.offsetWidth;
      root.classList.add('is-playing');
      timer = setTimeout(tick, interval);
    }
    function pause(on) { hold = on; root.classList.toggle('is-paused', on); if (on) stop(); else restart(); }

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.hcDot)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    root.addEventListener('mouseenter', function () { pause(true); });
    root.addEventListener('mouseleave', function () { pause(false); });
    root.addEventListener('focusin', function () { pause(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) pause(false); });
    track.addEventListener('touchstart', function () { pause(true); }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { pause(false); }, 2500); }, { passive: true });

    // Drag to scroll with a mouse
    var dragging = false, sx = 0, sl = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) track.classList.add('is-drag');
      track.scrollLeft = sl - dx;
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false; track.classList.remove('is-drag');
      if (moved > 4) {
        var dx = e.clientX - sx, i = nearest();
        if (Math.abs(dx) > 40 && i === current) i = current + (dx < 0 ? 1 : -1);
        go(Math.max(0, Math.min(slides.length - 1, i)));
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) { if (moved > 4) { e.preventDefault(); e.stopPropagation(); } }, true);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) root.classList.add('is-in');
        if (visible) restart(); else stop();
      }, { threshold: 0.35 }).observe(root);
    } else { visible = true; root.classList.add('is-in'); restart(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else restart(); });
  }
  function all() { document.querySelectorAll('[data-hc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('[data-hc-slide]'); if (!s) return;
    s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.hrReady) return;
    root.dataset.hrReady = '1';
    var slides = root.querySelectorAll('.hero-rot__slide'), bars = root.querySelectorAll('[data-hr-go]');
    var cap = root.parentNode.querySelector('[data-hr-cap]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = Number(root.dataset.interval) || 5000, i = 0, t = null, held = false, seen = true;
    function show(n) {
      n = (n + slides.length) % slides.length;
      slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true');
      slides[n].classList.add('is-on'); slides[n].removeAttribute('aria-hidden');
      bars.forEach(function (b, k) { b.setAttribute('aria-current', k === n ? 'true' : 'false'); b.classList.toggle('is-done', k < n); });
      if (cap) {
        var txt = slides[n].dataset.cap;
        cap.classList.add('is-swap');
        setTimeout(function () { cap.textContent = txt; cap.classList.remove('is-swap'); }, 350);
      }
      i = n; play();
    }
    function play() {
      clearTimeout(t); root.classList.remove('is-playing');
      if (reduce || held || !seen || document.hidden) return;
      void root.offsetWidth; root.classList.add('is-playing');
      t = setTimeout(function () { show(i + 1); }, ms);
    }
    bars.forEach(function (b) { b.addEventListener('click', function () { show(Number(b.dataset.hrGo)); }); });
    var stage = root.parentNode;
    stage.addEventListener('mouseenter', function () { held = true; play(); });
    stage.addEventListener('mouseleave', function () { held = false; play(); });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; play(); }, { threshold: 0.2 }).observe(root);
    document.addEventListener('visibilitychange', play);
    play();
  }
  function all() { document.querySelectorAll('[data-hero-rot]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jury-sheet"]) return;
  try {
    
(function () {
  'use strict';
  var KEY = 'hs-jury';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(s) { try { localStorage.setItem(KEY, JSON.stringify({ s: s, t: Date.now() })); } catch (e) {} }

  function init() {
    var el = document.querySelector('[data-jury-sheet]');
    if (!el || el.__jsheet) return;
    el.__jsheet = true;
    var shown = false;

    function open(focusMsg) {
      if (shown) return;
      shown = true;
      el.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-on'); }); });
      if (focusMsg) { var m = el.querySelector('[data-jsheet-posted]'); if (m) setTimeout(function () { m.focus({ preventScroll: true }); }, 60); }
    }
    function close() {
      el.classList.remove('is-on');
      var st = read();
      if (!st || st.s !== 'joined') write('closed');
      setTimeout(function () { el.hidden = true; }, 500);
    }
    el.addEventListener('click', function (e) { if (e.target.closest('[data-jury-close]')) close(); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Back from this form: show the message (and never ask again after a signup).
    var posted = el.querySelector('[data-jsheet-posted]');
    if (posted && location.hash === '#JurySheetForm') {
      if (posted.getAttribute('data-jsheet-posted') === 'ok') write('joined');
      open(true);
      return;
    }
    // Signed up through any other form on the site.
    if (/[?&]customer_posted=true/.test(location.search)) { write('joined'); return; }

    var st = read();
    if (st && st.s === 'joined') return;
    var snooze = (Number(el.getAttribute('data-snooze')) || 14) * 864e5;
    if (st && st.s === 'closed' && Date.now() - st.t < snooze) return;

    var landing = el.getAttribute('data-landing') === '1';
    var delay = (Number(el.getAttribute('data-delay')) || 20) * 1000;
    var due = false;
    function okNow(exit) {
      if (shown) return false;
      var drawer = document.getElementById('CartDrawer');
      if (drawer && drawer.classList.contains('is-on')) return false;
      // Never over the first screen: wait until the visitor has scrolled past most of it (all of it on the ad landing page).
      if (!exit && window.scrollY < window.innerHeight * (landing ? 1 : 0.8)) return false;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return false;
      return true;
    }
    setTimeout(function () { due = true; if (okNow()) open(false); }, delay);
    window.addEventListener('scroll', function () { if (due && okNow()) open(false); }, { passive: true });
    if (window.matchMedia && matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && okNow(!landing)) open(false); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spin"] && !Shopify.designMode) return;
  try {
    
/* 360 viewer: drag, arrow keys, slow idle turn. Works with spin frames or the illustrated jar. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-spin]').forEach(function (stage) {
    var jar = stage.querySelector('.jar3d'), frames = stage.querySelectorAll('.spin__frame');
    var rot = 0, dragging = false, lastX = 0, idle = !reduce, visible = false, resume;
    var render = function () {
      if (jar) jar.style.setProperty('--rot', rot.toFixed(1) + 'px');
      if (frames.length) {
        var n = frames.length, i = ((Math.round(-rot / 14) % n) + n) % n;
        frames.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
      }
    };
    var pause = function () { idle = false; clearTimeout(resume); if (!reduce) resume = setTimeout(function () { idle = true; }, 4000); };
    stage.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; stage.setPointerCapture(e.pointerId); pause(); });
    stage.addEventListener('pointermove', function (e) { if (!dragging) return; rot += (e.clientX - lastX) * 1.4; lastX = e.clientX; render(); });
    ['pointerup', 'pointercancel'].forEach(function (t) { stage.addEventListener(t, function () { dragging = false; }); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { rot += e.key === 'ArrowRight' ? 30 : -30; render(); pause(); e.preventDefault(); }
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(stage);
    (function tick() { if (idle && visible && !dragging) { rot -= .35; render(); } requestAnimationFrame(tick); })();
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumor-game"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; }); }

  function setup(root) {
    if (!root || root.__rg) return;
    root.__rg = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rg-card]'));
    var end = root.querySelector('[data-rg-end]');
    var scoreEl = root.querySelector('[data-rg-score]');
    var finalEl = root.querySelector('[data-rg-final]');
    var shop = root.querySelector('[data-rg-shop]');
    var total = cards.length, i = 0, score = 0;
    if (!total || !end) return;
    if (shop && document.getElementById('buy')) shop.setAttribute('href', '#buy');

    function show(n, focus) {
      cards.forEach(function (c, k) { c.hidden = k !== n; });
      end.hidden = n !== total;
      if (n < total) {
        var c = cards[n];
        c.querySelectorAll('[data-rg-pick]').forEach(function (b) { b.disabled = false; b.removeAttribute('aria-pressed'); b.classList.remove('is-answer'); });
        c.querySelector('[data-rg-reveal]').hidden = true;
        scoreEl.textContent = n > 0 ? fill(root.getAttribute('data-running-text'), { score: score, total: total }) : '';
        if (focus) c.querySelector('.rg__rumor').focus({ preventScroll: true });
      } else {
        scoreEl.textContent = '';
        finalEl.textContent = fill(root.getAttribute('data-score-text'), { score: score, total: total });
        if (focus) finalEl.focus({ preventScroll: true });
      }
    }

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-rg-pick]');
      if (pick && root.contains(pick)) {
        var card = pick.closest('[data-rg-card]');
        var answer = card.getAttribute('data-answer');
        var ok = pick.getAttribute('data-rg-pick') === answer;
        if (ok) score++;
        card.querySelectorAll('[data-rg-pick]').forEach(function (b) {
          b.disabled = true;
          if (b === pick) b.setAttribute('aria-pressed', 'true');
          if (b.getAttribute('data-rg-pick') === answer) b.classList.add('is-answer');
        });
        card.querySelector('[data-rg-result]').textContent = (ok ? root.getAttribute('data-right') : root.getAttribute('data-wrong')) + ' ';
        var reveal = card.querySelector('[data-rg-reveal]');
        reveal.hidden = false;
        reveal.querySelector('.rg__why').focus({ preventScroll: true });
        scoreEl.textContent = fill(root.getAttribute('data-running-text'), { score: score, total: total });
        return;
      }
      if (e.target.closest('[data-rg-next]')) { i++; show(i, true); return; }
      if (e.target.closest('[data-rg-again]')) { i = 0; score = 0; show(0, true); }
    });

    root.classList.add('is-on');
    // Back from the signup form: open the last card so the visitor sees the message.
    if (root.querySelector('[data-rg-posted]') && location.hash === '#' + root.getAttribute('data-form-id')) {
      i = total; show(total, false);
      finalEl.textContent = '';
      root.scrollIntoView({ block: 'start' });
    } else {
      show(0, false);
    }
  }

  function init() { document.querySelectorAll('[data-rg]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-rg]'); if (r) setup(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reel"] && !Shopify.designMode) return;
  try {
    
/* Video carousel: plays muted clips while they are on screen, one clip with sound at a time. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (root.dataset.vrReady) return;
    root.dataset.vrReady = '1';
    var track = root.querySelector('[data-vr-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vr-card]'));
    var prev = root.querySelector('[data-vr-prev]'), next = root.querySelector('[data-vr-next]');
    var loud = null;
    root.querySelectorAll('.vr__item').forEach(function (li, i) { li.style.setProperty('--i', Math.min(i, 5)); });

    function vid(card) { return card.querySelector('video'); }
    function setLoud(card) {
      cards.forEach(function (c) {
        var v = vid(c), on = c === card, b = c.querySelector('[data-vr-sound]');
        c.classList.toggle('is-loud', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
        if (v) v.muted = !on;
      });
      loud = card;
      if (card) {
        var v = vid(card);
        if (v) { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
    }
    cards.forEach(function (card) {
      var v = vid(card);
      if (v) {
        v.removeAttribute('autoplay');
        v.muted = true; v.loop = true; v.playsInline = true;
        v.addEventListener('timeupdate', function () { if (v.duration) card.style.setProperty('--p', (v.currentTime / v.duration).toFixed(3)); });
      }
      card.addEventListener('click', function () {
        if (!v) return;
        load();
        if (loud === card) { setLoud(null); if (reduce) v.pause(); } else setLoud(card);
      });
    });

    /* v6.12: attach the video files once the reel is within ~1.5 screens */
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      cards.forEach(function (c) { var v = vid(c); if (v && v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.preload = 'metadata'; } });
    }
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(); near.disconnect(); } }, { rootMargin: '150% 0px' });
      near.observe(root);
    } else load();

    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = vid(e.target);
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            if (!reduce || loud === e.target) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else {
            v.pause();
            if (loud === e.target) setLoud(null);
          }
        });
      }, { threshold: [0, 0.6] });
      cards.forEach(function (c) { seen.observe(c); });
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) root.classList.add('is-in'); }, { threshold: 0.2 }).observe(root);
    } else { root.classList.add('is-in'); }

    function step() { var c = track.querySelector('.vr__item'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function edges() {
      if (!prev) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', edges, { passive: true });
    window.addEventListener('resize', edges);
    edges();
    document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(function (c) { var v = vid(c); if (v) v.pause(); }); });
  }
  function all() { document.querySelectorAll('[data-vr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();
})();
